import Vue from 'vue'
import App from './App.vue'
import router from './router'

//css do projeto
import './assets/css/main.scss';

//Bootstraps
import { BootstrapVue,BootstrapVueIcons} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import i18n from './i18n'



Vue.config.productionTip = false

import 'material-design-icons-iconfont/dist/material-design-icons.css'

import store from "./store"

import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo , {
  container: "body",
  duration: 1000,
  easing: "ease",
  offset: 150,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

import axios from 'axios'
import VueAxios from 'vue-axios'



axios.interceptors.response.use(
  response => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
      if (error.response.status) {
        switch (error.response.status) {
          case 404:
            alert('page not exist');
            break;
          case 500:
            console.log('erro 500')
            break;
          
        }
        return Promise.reject(error.response);
      }
  }
);


Vue.use(VueAxios, axios)

Vue.use(require('vue-moment'));

import { MdDialog, MdIcon, MdButton, MdCard, MdField, MdMenu, MdList, MdSubheader, MdDivider, MdCheckbox} from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

Vue.use(MdDialog)
Vue.use(MdIcon)
Vue.use(MdButton)
Vue.use(MdCard)
Vue.use(MdField)
Vue.use(MdMenu)
Vue.use(MdList)
Vue.use(MdSubheader)
Vue.use(MdDivider)
Vue.use(MdCheckbox)


// Install BootstrapVue
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons)



//Inicializa o Firebase

import * as firebase from 'firebase/app';
import 'firebase/auth';

import './firebaseInit';

  firebase.auth().onAuthStateChanged(user => {
    store.dispatch("fetchUser", user);
  });

  
 


 

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')